<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="list-item">
                <div class="r16 item bh bstart bbzlog fz_30">
                    <span>小八租车</span>
                    <div class="ico-bbzlog bg-contain"></div>
                    <span class="c_red fwb">4.9分</span>
                </div>
            </div>
            <div class="list-item">
                <div class="r16 item">
                    <div class="title fz_34 fwb">个人信息</div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">姓名</div>
                        {{infoData.customerName}}
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">身份证号码</div>
                        {{infoData.idNumber}}
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">手机号码</div>
                        {{infoData.orderMobile}}
                    </div>
                    <div class="c_333 fz_30 bh">
                        <div class="left-container">取车证件</div>
                        <div class="b1">本人身份证、驾驶证及信用卡</div>
                    </div>
                </div>
            </div>
            <div class="list-item">
                <div class="r16 item">
                    <div class="title fz_34 fwb">用车信息</div>
                    <div class="bh bstart">
                        <div class="b1">
                            <div class="bh bstart">
                                <div class="fz_30 c_333">取车时间</div>
                                <div class="fz_24 c_white tag r6">取车</div>
                            </div>
                            <div
                                class="c_999 fz_26 pb_10"
                            >{{infoData.getCarDate}} {{infoData.getWeek}}</div>
                            <div class="bh bstart">
                                <div class="fz_30 c_333">还车时间</div>
                                <div class="fz_24 c_white tag r6">还车</div>
                            </div>
                            <div
                                class="c_999 fz_26 pb_10"
                            >{{infoData.returnCarDate}} {{infoData.rtnWeek}}</div>
                        </div>
                        <div
                            class="c_red fz_34"
                        >共{{infoData.diffTime.day}}天{{infoData.diffTime.hours}}小时</div>
                    </div>
                    <div class="fz_30 c_333 ">取车地点：{{infoData.getStore}}</div>
                    <div class="c_999 fz_26 pb_10 breakword">{{infoData.getStoreAddress}}</div>
                    <div class="fz_30 c_333">还车地点：{{infoData.returnStore}}</div>
                    <div class="c_999 fz_26 pb_10 breakword">{{infoData.returnStoreAddress}}</div>
                    <div class="b"></div>
                    <div class="bh bstart c_666 fz_30">
                        <div class="ico-security bg-contain"></div>小八租车，出行有保障，安心任我行
                    </div>
                </div>
            </div>
            <van-collapse accordion v-model="activeNames">
                <van-collapse-item title="订单信息" name="1">
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">订单编号</div>
                        <div>{{infoData.orderNo}}</div>
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">创建时间</div>
                        <div>{{infoData.createAt}}</div>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <!-- 待取车显示 -->
            <van-collapse accordion v-model="activeNames1" v-if="infoData.status>=2">
                <van-collapse-item title="车辆信息" name="1">
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">车牌号</div>
                        {{infoData.licensePlate}}
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">车型</div>
                        {{infoData.realCarType}}
                    </div>
                </van-collapse-item>
            </van-collapse>
            <!-- 待还车显示 -->
            <van-collapse accordion v-model="activeNames2" v-if="infoData.status>=3">
                <van-collapse-item title="取车信息" name="1">
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">实际取车时间</div>
                        {{infoData.realGetCarDate}}
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">汽车油量</div>
                        {{infoData.getOil}}L
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">当前公里数</div>
                        {{infoData.getKilometer}}KM
                    </div>
                </van-collapse-item>
            </van-collapse>
            <!-- 待结算，已还车显示 -->
            <van-collapse accordion v-model="activeNames3" v-if="infoData.status>=4">
                <van-collapse-item title="还车信息" name="1">
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">实际还车时间</div>
                        {{infoData.realReturnCarDate}}
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">实际租期</div>
                        {{infoData.realDiffTime.day}}天{{infoData.realDiffTime.hours}}小时{{infoData.realDiffTime.mins}}分
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">汽车油量</div>
                        {{infoData.returnOil}}L
                    </div>
                    <div class="c_333 fz_30 pb_10 bh">
                        <div class="left-container">当前公里数</div>
                        {{infoData.returnKilometer}}KM
                    </div>
                </van-collapse-item>
            </van-collapse>
            <div class="list-item">
                <div class="r16 item bh c_666 fz_30">
                    <div class="ico-smile bg-contain"></div>
                    <div>
                        由小八租车提供预约服务，查看
                        <span
                            class="c_red"
                            @click.stop="go('DealInfo',{data:'cancelAgreement',title:'取消及用车须知'})"
                        >取消及用车须知</span>
                    </div>
                </div>
            </div>
            <div class="bv bc">
                <van-button @click="onTelClick" class="btn btn-submit-big">
                    <span class="fz_34">联系客服</span>
                </van-button>
                <!-- 待取车之前都可以取消订单 -->
                <van-button
                    class="btn btn-change"
                    @click="changeClick(infoData.orderNo)"
                    v-show="infoData.status<=2&&infoData.status>-1"
                >
                    <span class="fz_34">取消订单</span>
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { orderInfo, changeOrder } from "@/api/scooter";
import { user } from "@/mixin/user";
import { routeCache } from "@/mixin/cache";
import { callTel } from "@/utils/bridge";
import util from "@/utils/index";
import moment from "moment";
export default {
    mixins: [user, routeCache],
    name: "ScooterOrderInfo",
    data() {
        return {
            activeNames: "1",
            activeNames1: "1",
            activeNames2: "1",
            activeNames3: "1",
            infoData: { diffTime: {}},
            // 星期数组
            weekArr: [
                "星期天",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            ]
        };
    },
    methods: {
        onTelClick() {
            callTel(this.$store.state.tell);
        },
        // 获取用户数据后执行
        userLoginend() {
            const params = this.getCache();
            // 状态 0 待审核 1 待排车 2 待取车 3 待还车 4 待结算 5 已完成 -1 已取消
            orderInfo(params.id).then(res => {
                const data = res.data;
                data.diffTime = util.diffTime(
                    data.getCarDate,
                    data.returnCarDate
                );
                data.realDiffTime = util.diffTime(
                    data.realGetCarDate,
                    data.realReturnCarDate
                );
                data.getCarDate = moment(data.getCarDate).format(
                    "YYYY-MM-DD HH:mm"
                );
                data.returnCarDate = moment(data.returnCarDate).format(
                    "YYYY-MM-DD HH:mm"
                );
                data.getWeek = this.weekArr[moment(data.getCarDate).weekday()];
                data.rtnWeek = this.weekArr[
                    moment(data.returnCarDate).weekday()
                ];
                this.infoData = data;
                console.log(this.infoData);
            });
        },
        changeClick(id) {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "是否确认取消该租车需求？取消需求后将不再排车"
                })
                .then(() => {
                    changeOrder(id).then(() => {
                        this.userLoginend();
                        this.$store.state.scooter.isUpdateOrderList = true;
                    });
                });
        }
    }
};
</script>
<style scoped lang="scss">
.pb_10 {
    padding-bottom: 10px;
}
.tag {
    background-color: #ef7170;
    padding: 2px 7px;
    margin-left: 18px;
    line-height: 1.4;
}
.b {
    margin: 30px 0;
    border-bottom: 1px solid #dcdcdc;
}
.ico-security {
    width: 34px;
    height: 38px;
    margin-right: 12px;
}
.ico-smile {
    width: 38px;
    height: 38px;
    margin: 5px 12px 0 0;
}
.btn {
    width: 595px;
    height: 90px;
}
.btn-submit-big {
    margin: 90px 0 30px 0;
}
.btn-change {
    margin-bottom: 80px;
}
.topbar-container {
    background-color: #f7f8f8;
    .list-item {
        padding: 24px 30px 0 30px;
        .item {
            padding: 30px;
            background-color: #fff;
        }
        .title {
            padding-bottom: 30px;
        }
    }
}
/deep/.van-collapse {
    padding: 24px 30px 0 30px;
    background-color: #f7f8f8;
    .van-collapse-item {
        padding: 30px;
        background-color: #fff;
    }
    .van-cell:after {
        border: 0;
    }
    .van-cell {
        @include border-radius(16px 16px 0 0);
        padding: 0;
    }
    .van-cell__title {
        font-size: 34px;
        font-weight: bold;
    }
    .van-collapse-item__wrapper {
        @include border-radius(0 0 16px 16px);
        .van-collapse-item__content {
            padding: 30px 0 0 0;
        }
    }
}
.left-container {
    width: 200px;
}
</style>
